export enum MessageType {
  TEXT = 'text',
  MEDIA = 'media',
  FORWARD = 'forward',
  ISSUE = 'issue',
  ORDER = 'order',
  PRICE_LIST = 'priceList',
  INVOICE_LIST = 'invoiceList',
  SCHEME_LIST = 'schemeList',
  PAYMENT = 'payment',
  INVOICE = 'invoice',
  REQUIREMENT = 'requirement',
  CUSTOMER_NOT_FOUND = 'customerNotFound',
  WHATSAPP_TEMPLATE = 'waCustomTemplate',
  ZOEY_ORDER_REPORT = 'orderReport',
  ZOEY_INVOICE_REPORT = 'invoiceReport',
  LEDGER = 'ledger',
  CAMPAIGN = 'campaign',
  CHANNEL_UPDATE = 'CU',
  INTERACTIVE = 'interactive',
  DISPATCH = 'dispatch',
  TYPEBOT = 'typeBot',
  DISPACH_NOTE = 'dispatchList',
  ORDER_RECEIPT = 'orderReceipt',
  PAYMENT_RECEIPT = 'paymentReceipt',
  SURVEY_FORM = 'survey-form',
  UNKNOWN = 'unknown',
  TRIAL = 'trial',
  CONTACT = 'contact',
  CONTACTS = 'contacts',
  LOCATION = 'location',
  IMAGE = 'image',
}

export const ImageFileExtensions = [
  'svg',
  'gif',
  'jpeg',
  'jpg',
  'png',
  'webp',
  'bmp',
  'whatsapp-image',
  'sendPaymentRequestQR',
];

export const AudioFileExtensions = [
  'mp3',
  'mpeg',
  'wav',
  'm4a',
  'ogg',
  'aac',
  'mpga',
  'oga',
];

export const VideoFileExtensions = [
  '.mp4',
  '.mov',
  '.3gp',
  '.mkv',
  '.avi',
  '.m4v',
  '.webm',
];

export enum ChatActionType {
  // SEND_PRICES = 'Send Prices',
  ACCEPT_PAYMENT = 'ACCEPT PAYMENT',
  CREATE_DISPATCH_NOTES = 'Create Dispatch Note',
  SEND_PRICE_LIST = 'Send Price List',
  SEND_SCHEMES = 'Send Schemes',
  SEND_ORDERS = 'Send Orders',
  SEND_INVOICES = 'Send Invoices',
  SEND_LEDGER = 'Send Ledger',
  SEND_DISPATCH_NOTES = 'Send Dispatch Note',
  SEND_PAYMENT_RECEIPT = 'Send Payment Receipt',
  SEND_ORDER_RECEIPT = 'Send Order Receipt',
  SEND_PAYMENT_REQUEST = 'Send Payment Request',
  REVIEW_PAYMENT_INVOICE = 'Review Invoices',
  CREATE_INVOICE = 'Upload Invoice',
  CREATE_INVOICE_ACTION = 'Upload Invoice Action',
  VIEW_ORDER = 'View Order',
  VIEW_PAYMENT = 'View Payment',
  VIEW_ACTIVITIES = 'View Activities',
  VIEW_CART = 'View Cart',
  DETAILS = 'Details',
  SUMMARY = 'Summary',
  DOWNLOAD_INVOICE = 'Download Invoice',
  VIEW_INVOICE = 'View Invoice',
  PAYMENT_RECEIVED = 'Payment Received',
  PAYMENT_REJECTED = 'Payment Rejected',
  PRODUCT_DETAILS = 'Product Details',
  ACCEPT_CUSTOMER = 'Accept and create Customer',
  SEND_TEMPLATE = 'Send Template',
  TRIGGER_BOT = 'Trigger Bot',
  SEND_CAMPAIGNS = 'Send Campaigns',
  VIEW_CAMPAIGN = 'View Campaign',
  CREATE_ORDER = 'Create Order',
  UPLOAD_PAYMENT = 'Upload Payment',
  CREATE_PAYMENT = 'Create Payment',
  VIEW_ISSUE_THREAD = 'View Issue Thread',
  VIEW_DISPATCH_NOTE = 'View Dispatch Note',
  COLLECT_PAYMENT = 'Collect Payment',
  MESSAGE_INFO = 'Message Info',
  NONE = 'None',
  VIEW_WHATSAPP_GROUP_MESSAGES = 'View Whatsapp Group Messages',
  TAG_MANAGEMENT = 'Modify Tags',
  ADD_TAGS = 'Add Tags',
  REVIEW_AND_ACCEPT_PAYMENT = 'Review and Accept Payment',
  SURVAY_FORM_ANSWERS = 'Survey Form Answers',
  CREATE_CUSTOMER = 'Create Customer',
}

export enum CommerceActionType {
  SEND_PAYMENT_REQUEST = 'Send Payment Request',
}

export type MessageActionType =
  | 'reply'
  | 'delete'
  | 'forward'
  | 'issue'
  | 'view_order'
  | 'download_invoice'
  | 'reject_payment'
  | 'create_customer'
  | 'modify_tags'
  | 'accept_payment'
  | 'view_contact';

export enum MediaType {
  AUDIO = 'audio',
  DOCUMENT = 'document',
  IMAGE = 'image',
  STICKER = 'sticker',
  VIDEO = 'video',
}

export enum TemplateButtonTypeEnum {
  SYSTEM = 'system',
  URL = 'url',
  QUICK_REPLY = 'quick_reply',
  INTERACTIVE = 'interactive',
}
